<template>
    <footer class="footer">
        <span class="footer-left">Copyright 2023, Gagarinn hotel. All Rights Reserved.</span>
        <span class="footer-right">Designed by <a href="https://codedealer.pro/" target="_blank">CodeDealer</a></span>
    </footer>
</template>

<script>
    export default {
        name:'Footer'
    }
</script>
